import React from 'react'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { CardContent, Typography } from '@mui/material'

export type SearchEngineHeaderProps = ExtendableStyles & Testable

export function SearchEngineHeader(props: SearchEngineHeaderProps) {
  return (
    <CardContent component="header" {...props}>
      <Typography variant="h4">Search Engine</Typography>
      <Typography variant="subtitle1" color="textSecondary">
        Find companies in Crunchbase and LinkedIn (soon)
      </Typography>
    </CardContent>
  )
}
